import { useGroupList } from "../customHooks";
import React from "react";
import FormError from "./FormError";

function GroupSelect({
  formik,
  withDefault,
}: {
  formik: any;
  withDefault?: boolean;
}) {
  const { data, error } = useGroupList();
  const { setFieldValue } = formik;
  React.useEffect(() => {
    //  TODO: just first time, think about better alternatives
    if (data && withDefault && !formik.values?.group) {
      setFieldValue("group", data[0]._id);
    }
  }, [data]);
  if (data === undefined || data?.length === 0 || data === null) {
    return null;
  }

  return (
    <div style={{ minWidth: 200 }}>
      <select
        className="form-select form-select-solid"
        name={"group"}
        value={formik.values.group}
        onChange={(e) => {
          setFieldValue("group", e.target.value);
        }}
      >
        {!formik.values.group && (
          <option className={"py-3 "}>لطفا نام واحد را انتخاب کنید</option>
        )}
        {/*@ts-ignore*/}
        {data?.map((c) => (
          //<option key={c._id} value={c._id}>
          <option key={c._id} value={c.name}>
            {c.name}
          </option>
        ))}
      </select>
      <FormError formik={formik} fieldName={"group"} />
    </div>
  );
}

export default GroupSelect;
